import { getQuery } from "h3";
import { defineServerNegotiator } from "../helpers/defineServerNegotiator.js";
import { isValidLanguage } from "../../helpers/isValidLanguage.js";
export default defineServerNegotiator((options) => {
  return {
    negotiate(event) {
      const query = getQuery(event);
      for (const key of options.keys) {
        const value = query[key];
        if (value && typeof value === "string" && isValidLanguage(value)) {
          return value;
        }
      }
    }
  };
});
